module.exports = __webpack_public_path__ + "static/media/Apr10-S19.8363bce5.png";